var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "kirmizi-santral-webhooks" } },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", icon: "plus" },
                on: {
                  click: function ($event) {
                    _vm.showAddModal = true
                  },
                },
              },
              [_vm._v(" Webhook Ekle ")]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { icon: "reload", loading: _vm.loading },
                on: { click: _vm.refreshWebhooks },
              },
              [_vm._v(" Yenile ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.webhooks,
              loading: _vm.loading,
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              options: {
                fixedHeader: true,
                borderX: true,
                borderY: true,
              },
            },
            on: {
              "cursor-changed": function (cursor) {
                return (_vm.pagination = cursor)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.showAddModal,
            title: "Webhook Ekle",
            confirmLoading: _vm.saving,
            width: "600px",
          },
          on: { ok: _vm.handleSave, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "vertical" } },
            [
              _c(
                "a-form-item",
                { attrs: { label: "Webhook URL", required: "" } },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "https://webhook.site/...",
                      type: "url",
                    },
                    model: {
                      value: _vm.currentWebhook.responseurl,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentWebhook, "responseurl", $$v)
                      },
                      expression: "currentWebhook.responseurl",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "help-text" }, [
                    _vm._v(
                      "\n                    Webhook olaylarının gönderileceği URL adresi\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "URL Token (Opsiyonel)" } },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "Bearer token veya doğrulama anahtarı",
                    },
                    model: {
                      value: _vm.currentWebhook.urltoken,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentWebhook, "urltoken", $$v)
                      },
                      expression: "currentWebhook.urltoken",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "help-text" }, [
                    _vm._v(
                      "\n                    Webhook güvenliği için kullanılacak token (isteğe bağlı)\n                "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Webhook Sil", confirmLoading: _vm.deleting },
          on: {
            ok: _vm.confirmDelete,
            cancel: function ($event) {
              _vm.showDeleteModal = false
            },
          },
          model: {
            value: _vm.showDeleteModal,
            callback: function ($$v) {
              _vm.showDeleteModal = $$v
            },
            expression: "showDeleteModal",
          },
        },
        [
          _c("p", [_vm._v("Bu webhook'u silmek istediğinize emin misiniz?")]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(_vm._s(_vm.$_.get(_vm.deletingWebhook, "responseurl"))),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h3", [_vm._v("Webhooklar")]),
      _vm._v(" "),
      _c("p", [_vm._v("Kırmızı Santral webhook'larını yönetin")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }